<template>
  <div id="home">
    <div class="d-flex flex-column">
      <navbar-view class="navbar_view"></navbar-view>
      <div class="d-flex" style="height: 100%; width: 100%; margin-top: 50px">
        <div style="height: 100%">
          <sidebar-view :main-page="mainPage" :billing-version="billingVersion"></sidebar-view>
        </div>

        <div class="vue_container">
          <div style="margin: 30px 24px 30px 40px">
            <billing-wrapper v-if="mainPage === 'manage_billing'" />
            <software-credits v-if="mainPage === 'software_credits'" />
            <digital-worker-activity v-if="mainPage === 'worker_activity'" />
            <invoices-table v-if="mainPage === 'invoices'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import NavbarView from '@/components/dashboard/NavbarView.vue';
import SidebarView from '@/components/dashboard/SidebarView.vue';
import BillingWrapper from '@/components/billing/BillingWrapper.vue';
import SoftwareCredits from '@/components/billing/SoftwareCredits.vue';
import InvoicesTable from '@/components/billing/InvoicesTable.vue';
import DigitalWorkerActivity from '@/components/billing/DigitalWorkerActivity.vue';
import { on } from '@/javascript/eventBus';
import { useRouter } from 'vue-router';
import DashboardService from '@/services/DashboardService';

const router = useRouter();
const mainPage = ref('manage_billing');
const billingVersion = ref('');

const redirect = () => {
  mainPage.value = localStorage.getItem('mainPage') || 'manage_billing';
  goToPage();
};

const goToPage = () => {
  localStorage.setItem('mainPage', mainPage.value);

  if (mainPage.value === 'manage_billing') {
    router.push('/manage_billing');
  } else if (mainPage.value === 'software_credits') {
    router.push('/software_credits');
  } else if (mainPage.value === 'worker_activity') {
    router.push('/worker_activity');
  } else if (mainPage.value === 'invoices') {
    router.push('/invoices');
  }
};

onMounted(async () => {
  redirect();
  on('page_changed', (data) => {
    mainPage.value = data.main_page;
    goToPage();
  });

  try {
    const response = await DashboardService.getBillingVersion();
    if (response?.version) {
      billingVersion.value = response.version;
    }
  } catch (error) {
    console.error('Error fetching billing version:', error);
  }
});
</script>

<style scoped>
.vue_container {
  height: calc(100vh - 50px);
  width: calc(100vw - 225px);
  overflow-y: scroll;
  margin-left: 225px;
  background: var(--background-color);
}

.navbar_view {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>
